const OUTLOOK_CALENDAR_OAUTH_STATE_KEY = "mem.outlook_calendar.oauth_state";

export const writeOutlookCalendarOAuthState = (state: string) => {
  window.localStorage.setItem(OUTLOOK_CALENDAR_OAUTH_STATE_KEY, state);
};

export const readOutlookCalendarOAuthState = (): string | null => {
  return window.localStorage.getItem(OUTLOOK_CALENDAR_OAUTH_STATE_KEY);
};

export const clearOutlookCalendarOAuthState = () => {
  window.localStorage.removeItem(OUTLOOK_CALENDAR_OAUTH_STATE_KEY);
};
